import { SilverwareVariantIcon } from './SilverwareVariantIcon';

/**
 * author: Austin Andrews
 * id A91FC6E1-2613-41E7-A8CA-58740B3322DA
 * name silverware-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-variant.svg
 * tags
 * - Food / Drink 
 * - Places 
 */
export const UtensilsVariantIcon = SilverwareVariantIcon;
export default UtensilsVariantIcon